import { postJsonData } from '../../../global/data/service'
import { logSafe } from '../../../global/formatters/string-formatter'

export const getSearchDataDiscovery = async (site, searchTerm, count) => {
  try {
    const url = `/api/${site}/search`

    const searchTerms = {
      query:
        site === 'cti-adv'
          ? `title:${searchTerm}|document.Title:${searchTerm}|document.Alternatetitle:${searchTerm}|document.Fundname:${searchTerm}|document.Cusip:${searchTerm}|document.Omni_Description:${searchTerm}|enriched_html.entities.text:${searchTerm}|document.Ticker:${searchTerm}|document.Omni_title:${searchTerm}|text:${searchTerm}`
          : `title:${searchTerm}^3|enriched_html.entities.text:${searchTerm}|text:${searchTerm}`,
      count: count,
      xReturn:
        site === 'cti-adv'
          ? ['title', 'metadata', 'enriched_html', 'document']
          : ['title', 'metadata', 'enriched_html'],
      passages: {
        enabled: false,
      },
    }

    const data = await postJsonData(url, searchTerms)

    return data
  } catch (err) {
    return { results: [] }
  }
}

const cache = {}

export const fetchData = async (url) => {
  if (!cache[url]) {
    cache[url] = { promise: fetch(url), promise2: null }
  }

  try {
    const response = await cache[url].promise
    if (!cache[url].promise2) {
      cache[url].promise2 = response.json()
    }
    const data = await cache[url].promise2
    return data
  } catch (e) {
    const errorMessage = `ERROR RETRIEVING DATA ${e} ${url}`
    console.log(logSafe(errorMessage))
  }
}
